module.exports = __webpack_public_path__ + "static/ybs2-983a239f5f2318226985c16f0f6d00f9.png";